import * as React from "react";

export const Search = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.8499 7.24999C2.8499 4.81994 4.81985 2.84999 7.2499 2.84999C9.67995 2.84999 11.6499 4.81994 11.6499 7.24999C11.6499 9.68005 9.67995 11.65 7.2499 11.65C4.81985 11.65 2.8499 9.68005 2.8499 7.24999ZM7.2499 1.64999C4.15711 1.64999 1.6499 4.1572 1.6499 7.24999C1.6499 10.3428 4.15711 12.85 7.2499 12.85C8.58016 12.85 9.80209 12.3862 10.7628 11.6114L13.3256 14.1743C13.56 14.4086 13.9399 14.4086 14.1742 14.1743C14.4085 13.9399 14.4085 13.56 14.1742 13.3257L11.6113 10.7629C12.3861 9.80218 12.8499 8.58026 12.8499 7.24999C12.8499 4.1572 10.3427 1.64999 7.2499 1.64999Z"
    />
);
